import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Promo } from '../../types'
import ActionTypes from './actionTypes'

type FetchPromosRequest = {
    type: typeof ActionTypes.PROMOS_FETCH_REQUEST;
    payload: never;
}

type FetchPromosFailure = {
    type: typeof ActionTypes.PROMOS_FETCH_FAILURE;
    payload: Error;
}

type FetchPromosSuccess = {
    type: typeof ActionTypes.PROMOS_FETCH_SUCCESS;
    payload: Promo[];
}

/**
 * Fetch promos in the DB
 */
function fetchPromos() {
    return createAction<RootState, Promo[], never>({
        endpoint: `${HUBBLE_API_TOKEN}/promos`,
        method: 'GET',
        types: [
            ActionTypes.PROMOS_FETCH_REQUEST,
            ActionTypes.PROMOS_FETCH_SUCCESS,
            ActionTypes.PROMOS_FETCH_FAILURE,
        ],
    })
}

export type FetchPromosActon = FetchPromosRequest
    | FetchPromosFailure
    | FetchPromosSuccess

export default fetchPromos
